/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddLssGroup200Response
 */
export interface AddLssGroup200Response {
    /**
     * 
     * @type {string}
     * @memberof AddLssGroup200Response
     */
    uuid?: string;
}

/**
 * Check if a given object implements the AddLssGroup200Response interface.
 */
export function instanceOfAddLssGroup200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AddLssGroup200ResponseFromJSON(json: any): AddLssGroup200Response {
    return AddLssGroup200ResponseFromJSONTyped(json, false);
}

export function AddLssGroup200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddLssGroup200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'uuid': !exists(json, 'uuid') ? undefined : json['uuid'],
    };
}

export function AddLssGroup200ResponseToJSON(value?: AddLssGroup200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'uuid': value.uuid,
    };
}

